/* eslint-disable */
export default {
  confirmationInfo:
    'Your unsaved edits on the previous call will be lost. Are you sure you want to work on the new call?',
  log: 'Log',
  save: 'Save and work on new',
  discard: 'Discard and work on new',
  stay: 'Stay on Previous Work',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
